import {
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";

import { ChevronDownIcon } from "@chakra-ui/icons";
import React from "react";
import TitleDefault from "../../TitleDefault";
import { useRouter } from "next/router";

export default function Sac() {
  const router = useRouter();

  return (
    <Flex
      id="sac"
      py={10}
      flexDir={["column-reverse", "column-reverse", "column-reverse", "row"]}
    >
      <Flex flexDir="column" w="full" maxW="50%">
        <TitleDefault subtitulo="sac" titulo="Atendimento" />
        <Text>
          Caso você tenha alguma reclamação em relação a algum produto
          adquirido, selecione a categoria que você se enquadra (
          <b>consumidor final</b>, ou <b>pessoa juridica</b> - atacadista ou
          lojista), e iremos lhe redirecionar para a página onde você preencherá
          o formulário para entrar em contato conosco.
        </Text>
        <Flex mt={10} w="full">
          <Menu>
            <MenuButton
              as={Button}
              w="full"
              rightIcon={<ChevronDownIcon color="#ED1B2F" />}
              borderRadius="8px"
              borderColor="#EFEFF1"
              textAlign="left"
              borderWidth="2px"
              bgColor="white"
              fontWeight="normal"
              fontSize="18px"
              color="#555"
              _hover={{ bgColor: "white" }}
              _focus={{ bgColor: "white" }}
              _expanded={{ bgColor: "white" }}
            >
              Selecione sua categoria
            </MenuButton>
            <MenuList>
              <MenuItem
                fontSize="18px"
                color="#00377B"
                onClick={() =>
                  router.push("/contato/formulario/consumidor-final")
                }
              >
                Consumidor Final
              </MenuItem>
              <MenuDivider />
              <MenuItem
                fontSize="18px"
                color="#00377B"
                onClick={() =>
                  router.push("/contato/formulario/pessoa-juridica")
                }
              >
                Pessoa Jurídica (atacadista ou lojista)
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
      <Flex flexDir="column" w="full" maxW="50%" alignItems="end">
        <Image
          src="/contato.png"
          w={["100%", "100%", "100%", "80%"]}
          position="relative"
          zIndex="1"
        />
      </Flex>
    </Flex>
  );
}
